import { useAuth0 } from '@auth0/auth0-react';
import jwt_decode from 'jwt-decode';
import { useEffect } from 'react';
import { getExpireDate } from "helpers";

export const GoogleOneTap = () => {

    const { loginWithRedirect } = useAuth0();     
    
    const onOneTapSignedIn = (response) => {  
        let expDate = getExpireDate(1);
        document.cookie = `auth0_redir=${
            window.location.href
        };expires=${expDate.toUTCString()};path=/`; 
        if(window?.dataLayer) {
            window.dataLayer.push({
                event: 'ga4.trackEvent',
                eventName: 'login',
                eventParams: {
                    state: 'success', 
                    channel: 'onetap',
                    section : 'inicio'
                }
            });
        }
        loginWithRedirect({
            authorizationParams: {                                   
                connection: 'google-oauth2',
                login_hint: jwt_decode(response.credential).email,
            }
        });
    }

    const initializeGSI = () => {
        window.google.accounts.id.initialize({
            client_id: process.env.NEXT_PUBLIC_AUTH0_GOOGLE_ID,
            callback: onOneTapSignedIn
        });

        window.google.accounts.id.prompt(notification => {

            // 1. Detectar cuando se muestra el prompt
            if (notification.isDisplayed()) {
                if (window?.dataLayer) {
                    window.dataLayer.push({
                        event: 'ga4.trackEvent',
                        eventName: 'onetap_view', 
                        eventParams: {
                            state: 'success',
                            section: 'inicio',
                            channel: 'onetap',
                        }
                    });
                }
                console.log('One Tap mostrado al usuario');
            }

            if(notification.isNotDisplayed()) {
                console.log("GOT isNotDisplayed",notification.getNotDisplayedReason())
            } else if (notification.isSkippedMoment()) {
                console.log("GOT isSkippedMoment",notification.getSkippedReason())
            } else if (notification.isDismissedMoment()) {
                console.log("GOT isDismissedMoment",notification.getDismissedReason())
            }
        })
    }
    

    const googleOneTap = () => {
        if (document.querySelector('script[src="https://accounts.google.com/gsi/client"]')) {
            return;
        }
        const scriptGsi = document.createElement('script');
        scriptGsi.src = 'https://accounts.google.com/gsi/client';
        scriptGsi.onload = initializeGSI;
        scriptGsi.async = true;
        document.querySelector('body').appendChild(scriptGsi);
    }

    useEffect(() => {
        googleOneTap();
    }, [])
    
  return <></>;
}